module.exports = __webpack_public_path__ + "static/media/Instagramicon.6b2b6bcd.png";